import React from 'react';

import baseStyles from '../../css/citations.module.css';
import headerStyles from './header.module.css';

function Header() {
  const styles = { ...headerStyles, ...baseStyles };
  return (
    <React.Fragment>
      <header data-testid="Header" id="header"
        className={styles.esThemeBrightDefault + ' ' + styles.esHeader + "  es-js-header"}>
        <div className={styles.esHeaderProduct}>
          <a aria-label="Product name" href="https://www.elsevier.com/"
            rel="noopener nofollow noreferrer" target="_blank">
            <div className={styles.esHeaderProductLogo}>
              <img
                alt="Elsevier apple tree logo"
                src="../nonsolus-elsevier-logo-2.svg"
                className={styles.esHeaderProductLogoImage}
              />
            </div>
          </a>
          <h1
            className={styles.esPageHeader + " " + styles.esHeadingH1 + ' ' + styles.noselect + ' ' + styles.esHeaderProduct + ' ' + styles.esThemeBrightDefault + ' ' + styles.esFontElsevierDisplay}>
            Analyze manuscript references
          </h1>
        </div>
      </header>
    </React.Fragment>
  );
}

export default Header;
